import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import AppBar from '@material-ui/core/AppBar';

import {tabsContainerStyle} from './styles/desktopStyle';

const styles = {
    root: {
        flexGrow: 1,
    },
};

class AppBarDesktop extends React.Component {
    state = {
        value: 0,
    };

    handleChange = (event, value) => {
     this.props.handleChange(value);
    };


    render() {
        const { classes } = this.props;

        return (
            <AppBar position="sticky" style={{background:'transparent', top: -200, marginTop: '-200px'}}>

                <Tabs
                style ={tabsContainerStyle}
                    value={this.props.value}
                    onChange={this.handleChange}
                    centered
                    variant='fullWidth'
                >
                    <Tab label="Home" />
                    <Tab label="Undergraduate" />
                    <Tab label="Graduate" />
                    <Tab label="Projects" />
                    <Tab label="About Me" /> *
                </Tabs>
            </AppBar>
        );
    }
}

AppBarDesktop.propTypes = {
    classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(AppBarDesktop);




// WEBPACK FOOTER //
// ./src/tabs/appBars/AppBarDesktop.js